import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import customReducer from "./store/reducers";
import { Provider } from "react-redux";
import { configureStore } from "@reduxjs/toolkit";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { msalConfig } from "./pages/public/adminLogin/AzureLogin/authConfig";
import { ApolloProvider, ApolloClient, InMemoryCache } from "@apollo/client";
import { socket, SocketContext } from "./utils/socket";
import { API_URL_SOCKET } from "./pages/constants/Statics";

if (process.env.REACT_APP_ENVIRONMENT === 'production') {
  const noop = () => { };
  console.log = noop;
  console.error = noop;
  console.warn = noop;
  console.info = noop;
  console.debug = noop;
  console.table = noop;
  console.time = noop;
  console.timeEnd = noop;
  console.trace = noop;
  console.group = noop;
  console.groupEnd = noop;
  console.groupCollapsed = noop;
  console.clear = noop;
  console.count = noop;
  console.countReset = noop;
  console.dir = noop;
  console.dirxml = noop;
  console.profile = noop;
  console.profileEnd = noop;
  console.timeLog = noop;
  console.timeStamp = noop;
  console.assert = noop;
}


const store = configureStore({
  reducer: customReducer, // Your root reducer
});
const client = new ApolloClient({
  uri: API_URL_SOCKET,
  cache: new InMemoryCache(),
});

const msalInstance = new PublicClientApplication(msalConfig);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <SocketContext.Provider value={socket}>
    <ApolloProvider client={client}>
      <MsalProvider instance={msalInstance}>
        <React.StrictMode>
          <Provider store={store}>
            <BrowserRouter>
              <App />
            </BrowserRouter>
          </Provider>
        </React.StrictMode>
      </MsalProvider>
    </ApolloProvider>
  </SocketContext.Provider>
);
